import { createSelector } from "reselect";
const selector = (state) => state.places;

export default createSelector([selector], (data) => data);